<template>
  <div>
    <AppLoading v-if="isLoading" />
    <div v-else>
      <header class="d-flex">
        <AppHeading class="mb-0 flex-1">Workflow Emails</AppHeading>
        <div class="d-flex">
          <AppIcon
            name="keyboard_arrow_left"
            class="px-2 py-1 box mr-1 cursor-pointer d-flex align-items-center"
          />
          <AppIcon
            name="keyboard_arrow_right"
            class="px-2 py-1 box mr-1 cursor-pointer  d-flex align-items-center"
          />

          <div
            class="search-container pl-1 position-relative d-flex align-items-center box"
          >
            <AppButton :raised="true" @click="modals.addModal = true">
              <AppIcon name="add" />
              Assign Template
            </AppButton>
          </div>
        </div>
      </header>
      <div class="main">
        <AppTable
          :rows="worflowEmails"
          class="table mt-4 table-hover"
          resourceName="Workflow Emails"
          @select="openEditModal"
        >
          <template #header>
            <th class="th">Name</th>
            <th class="th">Event</th>
            <th class="th">Email Subject</th>
          </template>
          <template #default="{ row: worflowEmail }">
            <td class="w-25">
              {{ approvalCustomLabel(worflowEmail.approvalWorkflowId) }}
            </td>
            <td class="w-25">
              {{ worflowEmail.action | decamelize }}
            </td>
            <td class="w-50">
              {{ emailCustomLabel(worflowEmail.emailTemplateId) }}
            </td>
            <td>
              <AppButton
                variant="danger"
                @click.stop="deleteEmail(worflowEmail.id)"
              >
                <AppIcon name="delete" />
              </AppButton>
            </td>
          </template>
        </AppTable>
      </div>
    </div>
    <NewWorkflowEmailModal
      v-if="modals.addModal"
      :workflowActions="workflowActions"
      @add="addEmail"
      @close="modals.addModal = false"
    />
    <EditWorkflowEmailModal
      v-else-if="modals.editModal"
      :editing="editing"
      :workflowActions="workflowActions"
      @update="updateEmail"
      @close="closeEditModal"
    />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import NewWorkflowEmailModal from '@cm/client/components/Partial/Modals/NewWorkflowEmailModal'
import EditWorkflowEmailModal from '@cm/client/components/Partial/Modals/EditWorkflowEmailModal'
export default {
  components: {
    NewWorkflowEmailModal,
    EditWorkflowEmailModal,
  },
  data () {
    return {
      editing: null,
      worflowEmails: [],
      isLoading: true,
      modals: {
        addModal: false,
        editModal: false,
      },
      workflowActions: [
        'proposalCreated',
        'proposalApproved',
        'proposalRejected',
        'proposalSuspended',
        'proposalVotedOn',
      ],
    }
  },
  computed: {
    ...mapGetters([ 'approvalWorkflows', 'approvalWorkflow' ]),
    ...mapState('curriculumEmails', [ 'templates' ]),
  },
  created () {
    this.isLoading = true
    setTimeout(() => {
      this.isLoading = false
    }, 1000)
  },
  methods: {
    approvalCustomLabel (id) {
      const workflow = this.approvalWorkflow(id)
      return workflow ? workflow.name : 'Workflow Not Found'
    },
    emailCustomLabel (id) {
      const index = this.templates.findIndex(t => t.id === id)
      return this.templates[index].subject
    },
    openEditModal (template) {
      this.editing = template
      this.modals.editModal = true
    },
    closeEditModal () {
      this.editing = null
      this.modals.editModal = false
    },
    addEmail (email) {
      this.worflowEmails.unshift(email)
    },
    deleteEmail (emailId) {
      this.isLoading = true
      setTimeout(() => {
        const index = this.worflowEmails.findIndex(e => e.id === emailId)
        this.worflowEmails.splice(index, 1)
        this.isLoading = false
      }, 1000)
    },
    updateEmail (email) {
      const index = this.worflowEmails.findIndex(e => e.id === email.id)
      if (index >= 0) {
        this.worflowEmails[index] = email
      }
    },
  },
}
</script>
